import React, { createContext, useContext } from 'react';
import { useV3State } from './useV3State';

// Create context for V3 state
const V3StateContext = createContext(null);

// Provider component
export function V3StateProvider({ children }) {
    const v3State = useV3State();
    
    return (
        <V3StateContext.Provider value={v3State}>
            {children}
        </V3StateContext.Provider>
    );
}

// Hook to use V3 state
export function useV3StateContext() {
    const context = useContext(V3StateContext);
    if (!context) {
        throw new Error('useV3StateContext must be used within V3StateProvider');
    }
    return context;
}

// Optional hook that returns null if not in provider (for legacy components)
export function useV3StateContextOptional() {
    return useContext(V3StateContext);
}